<!--
    描述：
    时间：2020-05-13
    Created by zwh
-->
<template>
    <div class="w-page-main">

    </div>
</template>

<script>
    export default {
        components: {},
        props : {},
        data() {
            return {

            }
        },
        computed: {},
        mounted() {},
        watch: {},
        created() {},
        methods: {

        }
    }
</script>

<style scoped>

</style>